module.exports = __webpack_public_path__ + "img/[鼓掌].15215845.svg";